import { WorkplanPublishStepCode, PublishStatusType } from 'src/Enums';
import { UPDATE_WORKPLAN_PUBLISH_PROGRESS } from './workplanPublishProgress.actions';

/** @type {WorkplanPublishProgress.IPublishProgress} */
const initialState = {
    workplanName: '',
    effectiveDate: '',
    endDate: '',
    isForeverRequestPeriod: false,
    status: PublishStatusType.Publishing,
    stepInfo: [],
    progressValue: 0,
    progressStepCode: WorkplanPublishStepCode.Loading,
    isComplete: false,
    isProgressSidePanelOpen: false,
};

/**
 * @param {WorkplanPublishProgress.IPublishProgress} state
 * @param {ShiftBidding.IAction} action
 * */
export default function workplanPublishProgressReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_WORKPLAN_PUBLISH_PROGRESS:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}
